var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHorizontalLight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 641,
    height: 99,
    viewBox: "0 0 641 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.1196 24.6372H119.729C129.218 24.6372 136.067 30.6625 136.067 38.917C136.067 45.3557 131.859 48.9051 129.136 50.3921C134.085 51.9613 139.944 56.3351 139.944 65.581C139.944 76.2291 132.601 83.2457 119.398 83.2457H97.1196V24.6372ZM116.923 46.5139C120.471 46.5139 122.04 44.6158 122.04 41.8909C122.04 38.8372 120.143 37.268 116.595 37.268H111.642V46.5139H116.923ZM118.489 70.6173C123.357 70.6173 125.503 67.977 125.503 64.0142C125.503 60.3004 123.442 57.6577 118.325 57.6577H111.642V70.6173H118.489Z",
    fill: "#B19CE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M145.555 24.6372H160.078V69.9549H180.87V83.2457H145.555V24.6372Z",
    fill: "#B19CE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.481 24.6372H201.004V83.2457H186.481V24.6372Z",
    fill: "#B19CE1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M208.265 24.6372H222.788L245.231 59.4711H245.644V24.6372H260.167V83.2457H245.644L223.201 48.4119H222.788V83.2457H208.265V24.6372Z",
    fill: "#B19CE1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M267.429 24.6372H291.44C306.787 24.6372 319.413 36.8546 319.413 53.9415C319.413 71.0284 306.79 83.2457 291.44 83.2457H267.429V24.6372ZM290.945 69.5438C299.856 69.5438 304.23 63.0229 304.23 53.9415C304.23 44.8625 299.858 38.3416 290.945 38.3416H281.952V69.5438H290.945Z",
    fill: "#B19CE1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M333.827 26.146H347.78V82.4575H333.827V26.146Z",
    fill: "#D0C4D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M354.756 26.146H368.71L390.273 59.6146H390.67V26.146H404.624V82.4575H390.67L369.107 48.9888H368.71V82.4575H354.756V26.146Z",
    fill: "#D0C4D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M409.618 69.0532L420.875 63.8193C422.461 67.0716 424.997 70.7189 429.913 70.7189C433.164 70.7189 436.097 69.1322 436.097 65.3247C436.097 62.6276 434.827 61.2802 429.834 59.2963L426.346 57.9489C419.052 55.0149 411.68 50.9704 411.68 41.3737C411.68 31.3798 420.083 25.3538 429.992 25.3538C439.982 25.3538 446.166 31.4611 448.941 37.4082L438.635 43.2786C436.178 39.1552 433.482 37.6475 430.549 37.6475C427.616 37.6475 425.397 38.9159 425.397 41.613C425.397 43.6759 426.585 45.3416 432.293 47.5624L436.099 49.0701C446.484 53.2725 450.606 57.9535 450.606 65.4873C450.606 77.623 439.745 83.2519 430.152 83.2519C420.162 83.2496 411.759 77.3025 409.618 69.0532Z",
    fill: "#D0C4D9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M455.601 26.146H469.555V82.4575H455.601V26.146Z",
    fill: "#D0C4D9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M475.738 54.3016C475.738 36.616 489.453 25.3538 505.308 25.3538C513.394 25.3538 522.908 28.3668 528.694 38.4397L518.626 45.3392C515.693 40.9765 511.411 38.5976 505.545 38.5976C496.983 38.5976 490.087 44.3078 490.087 54.3016C490.087 64.2955 496.589 70.4819 505.466 70.4819C510.54 70.4819 515.296 68.498 517.121 62.4719H505.547V50.9727H530.677C534.007 71.2764 520.848 83.2519 504.99 83.2519C489.216 83.2496 475.738 71.9896 475.738 54.3016Z",
    fill: "#D0C4D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M570.794 60.4881H551.212V82.4575H537.258V26.146H551.212V47.7181H570.794V26.146H584.748V82.4575H570.794V60.4881Z",
    fill: "#D0C4D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M602.269 38.916H589.744V26.146H628.748V38.916H616.223V82.4575H602.269V38.916Z",
    fill: "#D0C4D9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9217 58.996V63.3171C68.9217 65.1713 68.1516 66.9145 66.8367 68.1539C66.465 68.5052 66.0517 68.816 65.5978 69.0769L64.9242 69.4667L64.2594 69.8504L55.211 75.0796L42.6102 82.3566C40.5514 83.5431 38.0188 83.5431 35.9631 82.3566L12.9729 69.0769C10.9172 67.8873 9.64648 65.6931 9.64648 63.3176V36.7611C9.64648 34.3851 10.9172 32.1883 12.9729 31.0019L30.8885 20.6544L35.9631 17.7247C36.3173 17.5197 36.6895 17.3497 37.0669 17.2152C37.1285 17.1915 37.1927 17.171 37.2574 17.151C37.4622 17.0837 37.6702 17.0277 37.8812 16.984C37.9484 16.9691 38.0157 16.9548 38.0835 16.9429C38.2154 16.9193 38.3499 16.8988 38.4844 16.8813C38.5984 16.8664 38.7129 16.8551 38.8269 16.8489C38.8531 16.8459 38.8798 16.8433 38.906 16.8433C38.9321 16.8402 38.9614 16.8402 38.9907 16.8376H39.0143V21.6215C39.0143 23.2913 40.3702 24.6478 42.0362 24.6478H48.8328L48.877 25.4712V39.8963C48.877 41.563 50.2329 42.9164 51.8989 42.9164H62.772L62.7838 43.8862V55.9733C62.7838 57.4232 63.8086 58.639 65.1732 58.9292C65.3755 58.9734 65.586 58.9965 65.8027 58.9965H68.9217V58.996Z",
    fill: "#D2C1F5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9257 69.4682L64.2608 69.8519L55.2124 75.0811L42.6117 82.3581C40.5529 83.5446 38.0202 83.5446 35.9645 82.3581L12.9744 69.0784C11.8823 68.4456 11.0126 67.5313 10.4355 66.4563C9.92879 65.504 9.64795 64.4321 9.64795 63.3186V36.7631C9.64795 34.3871 10.9186 32.1903 12.9744 31.0039L30.8899 20.6564L35.9645 17.7267C36.3188 17.5217 36.691 17.3517 37.0684 17.2171C37.13 17.1935 37.1942 17.173 37.2588 17.1529C37.4637 17.0857 37.6716 17.0297 37.8826 16.986C37.9499 16.9711 38.0172 16.9567 38.0849 16.9449C38.2169 16.9213 38.3514 16.9007 38.4859 16.8833C38.5999 16.8684 38.7144 16.8571 38.8284 16.8509C38.8812 16.8453 38.9367 16.8422 38.9921 16.8391H39.0157V16.9418C36.3804 20.6009 34.9336 25.1126 34.9336 29.6207C34.9336 30.6839 35.0127 31.7445 35.1764 32.7964C36.0287 38.2187 39.0917 43.2492 43.4609 46.5564C44.2017 47.1219 44.9837 47.6376 45.7949 48.0942C49.3292 50.0835 53.3908 51.047 56.8055 53.2325C60.9344 55.8777 63.8804 60.3046 64.7239 65.1383C64.9729 66.5683 65.0402 68.0213 64.9257 69.4682Z",
    fill: "#D2C1F5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.722 65.1383C63.8784 60.3045 62.3548 60.6255 62.8256 51.98C62.8256 50.7253 62.8256 47.4063 62.8256 46.7042L52.1449 53.0743L41.8294 59.0313C40.4149 59.8479 38.6724 59.8495 37.2569 59.0349L29.6876 54.6793C28.267 53.8622 27.3916 52.3475 27.3916 50.708V26.8023C27.3916 24.4263 28.6623 22.2295 30.718 21.0431L37.6497 17.0383C37.5177 17.0733 37.3863 17.1087 37.2574 17.1524C37.1932 17.1729 37.1285 17.1934 37.0669 17.2166C36.6891 17.3511 36.3173 17.5211 35.9631 17.7261L30.8885 20.6558L12.9724 31.0033C10.9167 32.1898 9.646 34.387 9.646 36.7626V46.9102V63.3185C9.646 63.4618 9.65113 63.6046 9.66037 63.7469C9.66397 63.8049 9.67167 63.8624 9.6768 63.9205C9.6845 64.0027 9.69118 64.0853 9.70144 64.167C9.7112 64.241 9.72403 64.3139 9.73636 64.3874C9.74714 64.4516 9.75638 64.5158 9.7687 64.58C9.78462 64.6611 9.80361 64.7407 9.8221 64.8214C9.83493 64.8758 9.84674 64.9308 9.8606 64.9852C9.88217 65.0684 9.90681 65.1506 9.93145 65.2323C9.94686 65.2831 9.96123 65.334 9.97818 65.3843C10.0044 65.4649 10.0331 65.544 10.0629 65.6237C10.0824 65.676 10.1014 65.7284 10.1224 65.7803C10.1512 65.8527 10.182 65.9241 10.2133 65.9955C10.24 66.0566 10.2677 66.1172 10.296 66.1773C10.3237 66.2349 10.3519 66.2924 10.3812 66.3494C10.3997 66.3854 10.4156 66.4218 10.4346 66.4578C10.4521 66.4907 10.4726 66.522 10.4911 66.5549C10.527 66.6196 10.5645 66.6833 10.603 66.747C10.6405 66.8091 10.678 66.8702 10.7175 66.9313C10.7601 66.9971 10.8043 67.0613 10.8489 67.1255C10.8885 67.182 10.928 67.2385 10.9691 67.2935C11.0184 67.3592 11.0692 67.4234 11.121 67.4876C11.1621 67.5385 11.2027 67.5898 11.2453 67.6396C11.3012 67.7054 11.3598 67.7686 11.4188 67.8322C11.4609 67.878 11.5025 67.9242 11.5456 67.9684C11.6098 68.0341 11.6765 68.0968 11.7438 68.1599C11.7854 68.1995 11.8265 68.2395 11.8691 68.2781C11.943 68.3443 12.0205 68.4075 12.0981 68.4707C12.1371 68.5025 12.1751 68.5359 12.2151 68.5672C12.3034 68.6361 12.3953 68.7013 12.4877 68.766C12.5201 68.7886 12.5509 68.8128 12.5838 68.8348C12.7106 68.9201 12.8405 69.0023 12.9734 69.0793L35.9636 82.3591C38.0193 83.5456 40.5525 83.5456 42.6108 82.3591L55.2115 75.0821L58.6699 73.0841L58.6678 73.0846L64.2599 69.8528L64.9248 69.4692C65.0382 68.0213 64.971 66.5682 64.722 65.1383Z",
    fill: "#C4B1EE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5651 58.8993C62.5448 58.8993 62.7987 56.6987 62.7987 53.4824L55.211 57.7177L42.6103 64.9947C40.5515 66.1812 38.0188 66.1812 35.9631 64.9947L23.3542 57.7115C21.8283 56.8302 20.8877 55.2009 20.8877 53.4382V30.0986C20.8877 28.1946 21.702 26.4071 23.0841 25.1621L12.9724 31.0005C10.9167 32.187 9.646 34.3842 9.646 36.7598V45.9557V63.3162C9.646 63.4595 9.65113 63.6023 9.66037 63.7446C9.66397 63.8026 9.67167 63.8601 9.6768 63.9182C9.6845 64.0004 9.69118 64.0831 9.70144 64.1647C9.7112 64.2387 9.72403 64.3116 9.73636 64.3851C9.74714 64.4493 9.75638 64.5135 9.7687 64.5777C9.78462 64.6588 9.80361 64.7384 9.8221 64.8191C9.83493 64.8735 9.84674 64.9285 9.8606 64.9829C9.88217 65.0661 9.90681 65.1483 9.93145 65.23C9.94686 65.2808 9.96123 65.3317 9.97818 65.382C10.0044 65.4626 10.0331 65.5417 10.0629 65.6214C10.0824 65.6737 10.1014 65.7261 10.1224 65.778C10.1512 65.8504 10.182 65.9218 10.2133 65.9932C10.24 66.0543 10.2677 66.115 10.296 66.175C10.3237 66.2326 10.3519 66.2901 10.3812 66.3471C10.3997 66.3831 10.4156 66.4195 10.4346 66.4555C10.4521 66.4884 10.4726 66.5197 10.4911 66.5526C10.527 66.6173 10.5645 66.681 10.603 66.7447C10.6405 66.8068 10.678 66.8679 10.7175 66.929C10.7601 66.9948 10.8043 67.059 10.8489 67.1232C10.8885 67.1797 10.928 67.2362 10.9691 67.2912C11.0184 67.3569 11.0692 67.4211 11.121 67.4853C11.1621 67.5361 11.2027 67.5875 11.2453 67.6373C11.3012 67.7031 11.3598 67.7663 11.4188 67.8299C11.4609 67.8757 11.5025 67.9219 11.5456 67.9661C11.6098 68.0318 11.6765 68.0945 11.7438 68.1576C11.7854 68.1972 11.8265 68.2372 11.8691 68.2758C11.943 68.342 12.0205 68.4052 12.0981 68.4684C12.1371 68.5002 12.1751 68.5336 12.2151 68.5649C12.3034 68.6338 12.3953 68.699 12.4877 68.7637C12.5201 68.7863 12.5509 68.8105 12.5838 68.8325C12.7106 68.9178 12.8405 69 12.9734 69.077L35.9636 82.3568C38.0193 83.5433 40.5525 83.5433 42.6108 82.3568L55.2115 75.0798L64.2599 69.8505L64.9248 69.4669C64.9304 69.4083 64.9335 69.3528 64.9366 69.2938L64.9356 69.2943C65.0305 67.9029 66.8039 60.2722 66.5651 58.8993Z",
    fill: "#BBA8E4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9379 63.803C68.9379 62.9939 68.9379 58.8428 68.9379 58.8428H66.792L55.21 65.7569L42.6093 73.034C40.5505 74.2205 38.0178 74.2205 35.9621 73.034L16.188 61.6125C15.0297 60.9438 14.3161 59.707 14.3161 58.3695L14.3151 32.961C14.3151 31.8187 14.6077 30.7113 15.1468 29.7441L12.9709 31.001C10.9152 32.1875 9.64453 34.3847 9.64453 36.7603V53.9949V63.3167C9.64453 63.46 9.64967 63.6028 9.65891 63.7451C9.6625 63.8031 9.6702 63.8606 9.67534 63.9187C9.68304 64.0009 9.68971 64.0836 9.69998 64.1652C9.70973 64.2392 9.72257 64.3121 9.73489 64.3856C9.74567 64.4498 9.75492 64.514 9.76724 64.5782C9.78315 64.6593 9.80215 64.7389 9.82063 64.8196C9.83347 64.874 9.84528 64.929 9.85914 64.9834C9.8807 65.0666 9.90535 65.1488 9.92999 65.2305C9.94539 65.2813 9.95977 65.3322 9.97671 65.3825C10.0029 65.4631 10.0316 65.5422 10.0614 65.6219C10.0809 65.6743 10.0999 65.7266 10.121 65.7785C10.1497 65.8509 10.1805 65.9223 10.2119 65.9937C10.2386 66.0548 10.2663 66.1155 10.2945 66.1755C10.3222 66.2331 10.3505 66.2906 10.3797 66.3476C10.3982 66.3836 10.4141 66.42 10.4331 66.456C10.4506 66.4889 10.4711 66.5202 10.4896 66.5531C10.5255 66.6178 10.563 66.6815 10.6015 66.7452C10.639 66.8073 10.6765 66.8684 10.716 66.9295C10.7586 66.9953 10.8028 67.0595 10.8475 67.1237C10.887 67.1802 10.9265 67.2367 10.9676 67.2917C11.0169 67.3574 11.0677 67.4216 11.1196 67.4858C11.1606 67.5366 11.2012 67.588 11.2438 67.6378C11.2998 67.7036 11.3583 67.7668 11.4173 67.8304C11.4594 67.8762 11.501 67.9224 11.5442 67.9666C11.6083 68.0323 11.6751 68.095 11.7423 68.1581C11.7839 68.1977 11.825 68.2377 11.8676 68.2763C11.9415 68.3425 12.0191 68.4057 12.0966 68.4689C12.1356 68.5007 12.1736 68.5341 12.2137 68.5654C12.302 68.6343 12.3939 68.6995 12.4863 68.7642C12.5186 68.7868 12.5494 68.811 12.5823 68.833C12.7091 68.9183 12.839 69.0005 12.972 69.0775L35.9621 82.3573C38.0178 83.5438 40.551 83.5438 42.6093 82.3573L55.21 75.0803L64.9233 69.4674C67.4604 68.4466 68.9379 65.3157 68.9379 63.803Z",
    fill: "#A08BCF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3181 24.6418H51.8988C51.4424 24.6418 51.0728 25.0117 51.0728 25.4683V39.8934C51.0728 40.35 51.4424 40.7198 51.8988 40.7198H66.3181C66.7745 40.7198 67.1441 40.35 67.1441 39.8934V25.4683C67.1441 25.0122 66.7745 24.6418 66.3181 24.6418Z",
    fill: "url(#paint0_linear_1290_8921)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4643 12.3652H42.0351C41.5786 12.3652 41.209 12.735 41.209 13.1917V21.6244C41.209 22.081 41.5786 22.4508 42.0351 22.4508H50.4643C50.9207 22.4508 51.2904 22.081 51.2904 21.6244V13.1917C51.2904 12.735 50.9207 12.3652 50.4643 12.3652Z",
    fill: "url(#paint1_linear_1290_8921)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8017 56.7998H77.8833C78.3398 56.7998 78.7094 56.43 78.7094 55.9733V43.8867C78.7094 43.4301 78.3398 43.0603 77.8833 43.0603H65.8017C65.3452 43.0603 64.9756 43.4301 64.9756 43.8867V55.9733C64.9756 56.4294 65.3458 56.7998 65.8017 56.7998Z",
    fill: "url(#paint2_linear_1290_8921)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8271 43.8867V48.5982C79.8271 49.0548 80.1968 49.4246 80.6532 49.4246H85.3628C85.8192 49.4246 86.1889 49.0548 86.1889 48.5982V43.8867C86.1889 43.4301 85.8192 43.0603 85.3628 43.0603H80.6532C80.1973 43.0603 79.8271 43.4301 79.8271 43.8867Z",
    fill: "url(#paint3_linear_1290_8921)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6252 17.4741H54.0287C53.5723 17.4741 53.2026 17.8439 53.2026 18.3005V21.8985C53.2026 22.3551 53.5723 22.7249 54.0287 22.7249H57.6252C58.0816 22.7249 58.4513 22.3551 58.4513 21.8985V18.3005C58.4513 17.8439 58.0816 17.4741 57.6252 17.4741Z",
    fill: "url(#paint4_linear_1290_8921)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0819 12.3652H54.0287C53.5723 12.3652 53.2026 12.735 53.2026 13.1917V15.2456C53.2026 15.7023 53.5723 16.0721 54.0287 16.0721H56.0819C56.5383 16.0721 56.9079 15.7023 56.9079 15.2456V13.1917C56.9079 12.735 56.5383 12.3652 56.0819 12.3652Z",
    fill: "url(#paint5_linear_1290_8921)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5331 12.3652H59.1143C58.6575 12.3652 58.2876 12.7353 58.2876 13.1923V13.6112C58.2876 14.0682 58.6575 14.4383 59.1143 14.4383H59.5331C59.9898 14.4383 60.3598 14.0682 60.3598 13.6112V13.1923C60.3598 12.7353 59.9898 12.3652 59.5331 12.3652Z",
    fill: "url(#paint6_linear_1290_8921)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8573 15.8386H69.4385C68.9818 15.8386 68.6118 16.2087 68.6118 16.6657V17.0846C68.6118 17.5416 68.9818 17.9116 69.4385 17.9116H69.8573C70.3141 17.9116 70.684 17.5416 70.684 17.0846V16.6657C70.684 16.2087 70.3135 15.8386 69.8573 15.8386Z",
    fill: "url(#paint7_linear_1290_8921)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9662 22.7222H65.9623C66.4187 22.7222 66.7883 22.3524 66.7883 21.8958V16.8982C66.7883 16.4416 66.4187 16.0718 65.9623 16.0718H60.9662C60.5098 16.0718 60.1401 16.4416 60.1401 16.8982V21.8963C60.1401 22.3524 60.5098 22.7222 60.9662 22.7222Z",
    fill: "url(#paint8_linear_1290_8921)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5893 22.7217H71.4735C71.9299 22.7217 72.2996 22.3519 72.2996 21.8953V20.0103C72.2996 19.5536 71.9299 19.1838 71.4735 19.1838H69.5893C69.1328 19.1838 68.7632 19.5536 68.7632 20.0103V21.8953C68.7632 22.3519 69.1334 22.7217 69.5893 22.7217Z",
    fill: "url(#paint9_linear_1290_8921)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M69.706 23.9993H69.5899C69.1331 23.9993 68.7632 24.3694 68.7632 24.8263V24.9425C68.7632 25.3994 69.1331 25.7695 69.5899 25.7695H69.706C70.1628 25.7695 70.5327 25.3994 70.5327 24.9425V24.8263C70.5327 24.3699 70.1628 23.9993 69.706 23.9993Z",
    fill: "url(#paint10_linear_1290_8921)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5962 25.7695H72.7124C73.1691 25.7695 73.5391 25.3994 73.5391 24.9425V24.8263C73.5391 24.3694 73.1691 23.9993 72.7124 23.9993H72.5962C72.1395 23.9993 71.7695 24.3694 71.7695 24.8263V24.9425C71.7695 25.3994 72.1395 25.7695 72.5962 25.7695Z",
    fill: "url(#paint11_linear_1290_8921)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6378 33.6409H69.6698C69.2134 33.6409 68.8438 34.0107 68.8438 34.4673V40.4377C68.8438 40.8943 69.2134 41.2641 69.6698 41.2641H75.6378C76.0942 41.2641 76.4638 40.8943 76.4638 40.4377V34.4673C76.4638 34.0112 76.0937 33.6409 75.6378 33.6409Z",
    fill: "url(#paint12_linear_1290_8921)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8441 41.2647H80.581C81.0375 41.2647 81.4071 40.8949 81.4071 40.4383V38.7007C81.4071 38.2441 81.0375 37.8743 80.581 37.8743H78.8441C78.3877 37.8743 78.0181 38.2441 78.0181 38.7007V40.4383C78.0181 40.8949 78.3882 41.2647 78.8441 41.2647Z",
    fill: "url(#paint13_linear_1290_8921)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6698 31.8457H73.2658C73.7222 31.8457 74.0919 31.4759 74.0919 31.0193V27.4219C74.0919 26.9653 73.7222 26.5955 73.2658 26.5955H69.6698C69.2134 26.5955 68.8438 26.9653 68.8438 27.4219V31.0193C68.8438 31.4754 69.2134 31.8457 69.6698 31.8457Z",
    fill: "url(#paint14_linear_1290_8921)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8713 28.5383H76.2191C75.7627 28.5383 75.3931 28.9081 75.3931 29.3648V31.0176C75.3931 31.4742 75.7627 31.844 76.2191 31.844H77.8713C78.3277 31.844 78.6974 31.4742 78.6974 31.0176V29.3648C78.6974 28.9081 78.3277 28.5383 77.8713 28.5383Z",
    fill: "url(#paint15_linear_1290_8921)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2198 25.7676C75.763 25.7676 75.3931 26.1377 75.3931 26.5946C75.3931 27.0516 75.763 27.4217 76.2198 27.4217C76.6765 27.4217 77.0465 27.0516 77.0465 26.5946C77.0465 26.1377 76.6765 25.7676 76.2198 25.7676Z",
    fill: "url(#paint16_linear_1290_8921)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1290_8921",
    x1: 66.0332,
    y1: 24.6418,
    x2: 52.5831,
    y2: 21.3696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1290_8921",
    x1: 50.5935,
    y1: 12.3652,
    x2: 42.1564,
    y2: 10.3126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1290_8921",
    x1: 77.76,
    y1: 43.0603,
    x2: 66.2663,
    y2: 40.264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1290_8921",
    x1: 85.7491,
    y1: 43.0603,
    x2: 80.425,
    y2: 41.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1290_8921",
    x1: 58.0884,
    y1: 17.4741,
    x2: 53.6959,
    y2: 16.4055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1290_8921",
    x1: 56.6518,
    y1: 12.3652,
    x2: 53.5509,
    y2: 11.6108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1290_8921",
    x1: 60.2165,
    y1: 12.3652,
    x2: 58.4823,
    y2: 11.9433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1290_8921",
    x1: 70.5408,
    y1: 15.8386,
    x2: 68.8066,
    y2: 15.4167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1290_8921",
    x1: 66.3288,
    y1: 16.0718,
    x2: 60.765,
    y2: 14.7181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1290_8921",
    x1: 72.0551,
    y1: 19.1838,
    x2: 69.0955,
    y2: 18.4638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1290_8921",
    x1: 70.4104,
    y1: 23.9993,
    x2: 68.9295,
    y2: 23.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1290_8921",
    x1: 73.4167,
    y1: 23.9993,
    x2: 71.9358,
    y2: 23.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1290_8921",
    x1: 75.9371,
    y1: 33.6409,
    x2: 69.5599,
    y2: 32.0894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1290_8921",
    x1: 81.1728,
    y1: 37.8743,
    x2: 78.3366,
    y2: 37.1842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1290_8921",
    x1: 73.7291,
    y1: 26.5955,
    x2: 69.337,
    y2: 25.5269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1290_8921",
    x1: 78.469,
    y1: 28.5383,
    x2: 75.7036,
    y2: 27.8655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1290_8921",
    x1: 76.9322,
    y1: 25.7676,
    x2: 75.5485,
    y2: 25.4309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A08BCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2C1F5"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHorizontalLight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/horizontal-light.da275af5f77c833604220b3415ced5d1.svg";